"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeValuesDisplay = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Tag = _interopRequireDefault(require("@cimpress/react-components/lib/Tag"));

var _propTypes2 = require("../../shared/propTypes");

var _rangeTranslator = require("../../shared/formatters/rangeTranslator");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var RangeValuesDisplay = function RangeValuesDisplay(_ref) {
  var values = _ref.values,
      onValueRemoved = _ref.onValueRemoved;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null, values.map(function (rangeValue) {
      return rangeValue.range ?
      /*#__PURE__*/
      _react["default"].createElement(_Tag["default"], {
        value: formatMessage((0, _rangeTranslator.getRangeMessage)(rangeValue.range), rangeValue.range),
        key: JSON.stringify(rangeValue.range),
        removable: true,
        onRemoveClick: function onRemoveClick() {
          return onValueRemoved(rangeValue);
        }
      }) : null;
    }))
  );
};

exports.RangeValuesDisplay = RangeValuesDisplay;
RangeValuesDisplay.propTypes = {
  values: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)).isRequired,
  onValueRemoved: _propTypes["default"].func.isRequired
};
RangeValuesDisplay.defaultProps = {
  values: []
};